module.exports = __webpack_public_path__ + "media/images/element/help-center-c80edd4ccbc8c7e55b819c06be0f3ae3.svg";